import React from 'react';
import { getCtaConfig } from '../../../utils/usedPartGrades';
import { useThemeClasses } from '../../../hooks/useThemeClasses';

export default function UsedCtaSection({
  listing,
  onCheckAvailability,
  onExpressBuy,
  checking,
  expressLoading,
  requestSent,
  compact = false,
}) {
  const { isDark, sc } = useThemeClasses();
  const cfg = getCtaConfig(listing);
  const sizeClass = compact ? 'py-3 text-xs sm:text-sm' : '';

  if (requestSent) {
    return (
      <div
        className={`w-full rounded-sm border p-5 text-center sm:p-6 ${
          isDark
            ? 'border-emerald-700/50 bg-emerald-950/30'
            : 'border-emerald-200 bg-emerald-50'
        }`}
      >
        <p className={`font-semibold ${isDark ? 'text-emerald-200' : 'text-emerald-800'}`}>
          Request sent — awaiting seller response.
        </p>
        <p className={`mt-2 text-sm ${isDark ? 'text-emerald-300/80' : 'text-emerald-700'}`}>
          The seller will physically check this part and send you a photo within 4 hours.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full space-y-3">
      {!cfg.photosOk && (
        <div
          className={`w-full rounded-sm border px-4 py-3 text-sm ${
            isDark
              ? 'border-amber-700/50 bg-amber-950/30 text-amber-200'
              : 'border-amber-200 bg-amber-50 text-amber-800'
          }`}
        >
          Seller is completing photo verification.
        </div>
      )}

      {cfg.showExpressBuy ? (
        <div className="grid w-full grid-cols-1 gap-2.5 sm:grid-cols-2 sm:gap-3">
          <button
            type="button"
            onClick={onCheckAvailability}
            disabled={cfg.checkAvailabilityDisabled || checking}
            className={`${sc('pdpAddToCartBtn')} ${sizeClass} disabled:cursor-not-allowed`}
          >
            {checking ? 'Sending…' : 'Check Availability'}
          </button>
          <button
            type="button"
            onClick={onExpressBuy}
            disabled={expressLoading}
            className={`${sc('pdpBuyNowBtn')} ${sizeClass}`}
          >
            {expressLoading ? 'Loading…' : 'Express Buy'}
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={onCheckAvailability}
          disabled={cfg.checkAvailabilityDisabled || checking}
          className={`${sc('pdpBuyNowBtn')} w-full ${sizeClass} disabled:cursor-not-allowed`}
        >
          {checking ? 'Sending…' : 'Check Availability'}
        </button>
      )}
    </div>
  );
}
